<template>
  <main class="main-container">
    <div class="k-onboarding__quest-wrapper">
      <form class="k-onboarding__quest" @submit.prevent="login">
        <div class="k-onboarding__title">Вход</div>
        <p v-if="!requestError && getLoadUserError && getLoadUserError.network && !isLoading" role="alert">Не удалось выполнить вход. <button type="button" @click="loadUser({ force: true })">Повторить</button></p>
        <p v-if="requestError" role="alert" class="error-message">{{ requestError }}</p>
        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__email-input jq-onboarding-input', {'has-error': !!errors.email}]"
            type="email"
            autocomplete="username"
            placeholder="E-mail"
            title="E-mail"
            id="registration_email"
            v-model="form.email"
            @keydown="clearError('email')"
            @change="validateEmail"
            required
            :readonly="sessionAccepted"
            v-focus
          />
        </div>
        <div v-if="errors.email" class="error-message">{{errors.email}}</div>

        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__email-input jq-onboarding-input', {'has-error': !!errors.password}]"
            type="password"
            autocomplete="current-password"
            placeholder="Пароль"
            title="Пароль"
            id="registration_password"
            v-model="form.password"
            @keydown="clearError('password')"
            :required="!sessionAccepted"
            :readonly="sessionAccepted"
          />
        </div>
        <div v-if="errors.password" class="error-message">{{errors.password}}</div>

        <button
          type="submit"
          :disabled="isLoading || (!sessionAccepted && !canLogin)"
          :class="['k-onboarding__quest-next', {'active': sessionAccepted || canLogin}]"

        >
          <span v-if="!isLoading">{{ sessionAccepted ? 'Повторить' : 'Войти' }}</span>
          <the-spinner v-else low button/>
        </button>
        <router-link to="/registration" class="k-orange-link p-2">У меня нет аккаунта</router-link>
      </form>
    </div>
  </main>
</template>

<script>
import apiUser from '../api/UserApi';
import { LOADING_STATUS } from '../constants';

import { mapActions, mapGetters } from 'vuex';
import TheSpinner from '../components/TheSpinner.vue';

export default {
  name: "AuthLogin",
  components: {
    TheSpinner
  },
  data: function() {
    return {
      form: {
        email: '',
        password: '',
      },
      errors: {
        email: null,
        password: null,
      },
      isLoading: false,
      requestError: null,
      sessionAccepted: false,
    };
  },
  computed: {
    ...mapGetters(['getLoadUserError', 'getUserLoadingStatus']),
    isCheckingSession() { return this.getUserLoadingStatus === LOADING_STATUS.LOADING && !this.isLoading && !this.sessionAccepted; },
    canLogin: function() {
      return Object.values(this.form).every(el => !!el) && !Object.values(this.errors).some(el => !!el)
    }
  },
  methods: {
    ...mapActions([
      'loadUser', 'invalidateUserLoad'
    ]),
    validateEmail() {
      if (!this.form.email) {
        this.errors.email = "Поле E-mail обязательно для заполнения.";
      } else if (!/(.+)@(.+){2,}\.(.+){2,}/.test(this.form.email)) {
        this.errors.email = "Неверный формат поля E-mail.";
      }
    },
    clearError(field) {
      this.errors[field] = null;
    },
    async login() {
      if (this.isLoading || (!this.sessionAccepted && !this.canLogin)) return;
      this.requestError = null;
      this.isLoading = true;
      try {
        if (!this.sessionAccepted) {
          this.invalidateUserLoad();
          const { data } = await apiUser.login(this.form);
          if (!data.success) {
            for (const key in data.errors || {}) if (key in this.errors) this.errors[key] = data.errors[key];
            if (!data.errors) this.requestError = 'Не удалось выполнить вход. Проверьте данные.';
            return;
          }
          this.sessionAccepted = true;
          this.form.password = '';
        }
        await this.loadUser({ force: true });
        if (this.$store.getters.getUserLoadingStatus !== LOADING_STATUS.SUCCESS) {
          if (this.getLoadUserError && this.getLoadUserError.auth_required) {
            this.sessionAccepted = false;
            this.requestError = 'Сессия входа не сохранилась. Выполните вход ещё раз.';
          } else {
            this.requestError = 'Не удалось загрузить профиль. Повторите попытку.';
          }
        }
        // App resolves login/onboarding once the authoritative profile is ready.
      } catch (_) {
        this.requestError = this.sessionAccepted
          ? 'Не удалось загрузить профиль. Повторите загрузку.'
          : 'Не удалось выполнить вход. Проверьте соединение и повторите попытку.';
      } finally { this.isLoading = false; }
    }
  }
};
</script>

<style scoped>
.k-onboarding__quest { display: flex; }
.k-registration__input-wrapper, .k-registration__input { max-width: 100%; }
button.k-onboarding__quest-next { border: 0; max-width: 100%; font: inherit; cursor: pointer; }
button:disabled { cursor: default; opacity: .65; }
</style>
